module.exports = __webpack_public_path__ + "static/media/dog_bark.4d5eb741.ogg";